import { useGet, useQueryWithErrorHandling } from '@app/sdk';
import exp from 'constants';

function useStatementService() {
  const get = useGet(true, 'ams');

  function getStatement(accountId: string, billingPeriodId: number) {
    return get<Statement>(`/api/proxy/ams/statement-service/accounts/${accountId}/statements/${billingPeriodId}`);
  }

  function getAnnualStatement(accountId: string, annualStatementId: number) {
    return get<{
      value: any;
    }>(`/api/proxy/ams/statement-service/accounts/${accountId}/annual-statements/${annualStatementId}`);
  }

  function getAnnualStatements(accountId: string) {
    return get<{
      value: AnnualStatementHistory[];
    }>(`/api/proxy/ams/statement-service/accounts/${accountId}/annual-statements`);
  }

  return {
    getAnnualStatements,
    getStatement,
    getAnnualStatement,
  };
}

export function useGetStatement(accountId: string, billingPeriodId: number, currentBillingPeriodId: number) {
  const { getStatement } = useStatementService();
  return useQueryWithErrorHandling({
    queryKey: ['getStatement', accountId, billingPeriodId],
    queryFn: () => getStatement(accountId, billingPeriodId),
    enabled: !!accountId && !!billingPeriodId && currentBillingPeriodId !== 1,
  });
}

export function useGetAnnualStatement(accountId: string, annualStatementId: number) {
  const { getAnnualStatement } = useStatementService();
  return useQueryWithErrorHandling({
    queryKey: ['getAnnualStatement', accountId, annualStatementId],
    queryFn: () => getAnnualStatement(accountId, annualStatementId),
    enabled: !!accountId && !!annualStatementId,
  });
}

export function useGetAnnualStatements(accountId: string) {
  const { getAnnualStatements } = useStatementService();
  return useQueryWithErrorHandling({
    queryKey: ['getAnnualStatements', accountId],
    queryFn: () => getAnnualStatements(accountId),
    enabled: !!accountId,
  });
}
